import { AGENT_PHASES, type AgentPhase } from '../../constants';
import { Card } from '../../components/layout/Card';
import type { Itinerary, AgentEvent, FormData } from '../../types';
import { ItineraryDisplay } from './ItineraryDisplay';
import { SurveyActions } from './SurveyActions';

interface ItineraryPanelProps {
  phase: AgentPhase;
  itinerary: Itinerary | null;
  sessionId: string;
  agentEvents?: AgentEvent[];
  formData?: FormData | null;
  onRetry: () => void;
  onReset: () => void;
  onModifyTrip: () => void;
  onAcceptItinerary?: () => void;
}

export function ItineraryPanel({ phase, itinerary, sessionId, agentEvents, formData, onRetry, onReset, onModifyTrip, onAcceptItinerary }: ItineraryPanelProps) {
  if (phase === AGENT_PHASES.IDLE) return null;

  return (
    <Card style={{ background: 'transparent', border: 'none', boxShadow: 'none', width: '100%' }}>
      {itinerary && phase === AGENT_PHASES.COMPLETE && (
        <ItineraryDisplay
          itinerary={itinerary}
          agentEvents={agentEvents}
          formData={formData}
          onModifyTrip={onModifyTrip}
        />
      )}
      <SurveyActions
        phase={phase}
        hasItinerary={!!itinerary}
        onRetry={onRetry}
        onReset={onReset}
        onAcceptItinerary={onAcceptItinerary}
      />
    </Card>
  );
}
